(function () {
    'use strict';

    function WZCompanyScheduleController($scope, $timeout, $state, SettingInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader) {

        var $ctrl = this;
        loadPage();

        function initSchedule() {
            $timeout(function () {
                $ctrl.schedule = {};
                $ctrl.schedule.weeklyScheduleInfo = {};
                $ctrl.schedule.weeklyScheduleInfo.timePeriod = {};
                var startTime = new Date();
                startTime.setHours(8, 0, 0, 0);
                var endTime = new Date();
                endTime.setHours(17, 0, 0, 0);
                $ctrl.schedule.weeklyScheduleInfo.timePeriod.startTime = startTime;
                $ctrl.schedule.weeklyScheduleInfo.timePeriod.endTime = endTime;
                $ctrl.schedule.weeklyScheduleInfo.weekdays = [];
                angular.forEach(DAYS_VALUES, function (val) {
                    var weekday = {};
                    if (val != 'FRIDAY') {
                        weekday.weekday = val;
                        //weekday.timePeriod = $ctrl.schedule.weeklyScheduleInfo.timePeriod;
                        $ctrl.schedule.weeklyScheduleInfo.weekdays.push(weekday);
                    }
                });
            }, 500);


        }

        function loadAll() {
            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('serviceItem');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('company');
            translatePartialLoader = translate.refresh();
            initSchedule();
            //

            //$ctrl.SettingInfoDtails =  SettingInfoDtailCustom.SettingInfoDtailsByServiceItem($ctrl.serviceItemId).query();
        }

        $scope.$watch('CompanyScheduleform.$valid', function (isValid) {
            $ctrl.isFormValid(isValid);
        })


    }

    var WZCompanySchedule = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/wizard-forms/company-schedule/wizard-form.company-schedule.html',
        controller: WZCompanyScheduleController,
        bindings:
            {
                schedule: '=?',
                isFormValid: '=?'
            }

    };

    angular
        .module('tikonApp')
        .component('wzfCompanySchedule', WZCompanySchedule)

    WZCompanyScheduleController.$inject = ['$scope', '$timeout', '$state', 'SettingInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader'];


})();

